import { useCallback } from 'react';
/**
 * textでのenter入力時にfocusを外すuse
 * @param keywordRef
 * @returns {(function(*): void)|*}
 */
export const useInputBlurOnEnter = (keywordRef) => useCallback((e) => {
    if (e.keyCode !== 229 && e.key === 'Enter') {
        e.preventDefault();
        keywordRef.current.blur();
    }
}, [keywordRef]);
export default useInputBlurOnEnter;
